<template>
  <v-card class="tile" max-width="450" min-width="150px">
    <v-card-text>
      <div class="content d-flex flex-row align-center">
        <div class="icon mr-4">
          <v-icon medium>{{icon}}</v-icon>
        </div>
        <div class="data">
          <div class="count">{{count}}</div>
          <div class="name">{{name}}</div>
        </div>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "HeaderTile",
  props: {
    icon: String,
    count: Number,
    name: String
  }
};
</script>

<style scoped>
.theme--light.v-sheet {
  border-left: 5px solid #0e07b5;
}

.tile {
  margin: 10px;
  width: auto;
}

.content {
  padding: 10px;
}

.icon {
  background: #e7e6f8;
  padding: 10px;
  border-radius: 5px;
}

.data {
  color: #030236;
}

.count {
  font-weight: bolder;
  font-size: 20px;
  font-family: Candara, Arial, Helvetica, sans-serif;
}

.name {
  font-size: 12px;
}
</style>